/**********************************************************************************************************************/
/* FILE: hafas_webapp_subscription_reachability.js                                                                       */
/**********************************************************************************************************************/
/* Subscriptions Proximity */
HafasWebapp.prototype.subscriptions.Reachability = function (_me) {
  Hafas.ps.sub('/reachability/fromMapPos', Hafas.bind(_me.Controller.Reachability.searchFromMapPosition, _me));
  Hafas.ps.sub('/reachability/closeResult', Hafas.bind(_me.Controller.Reachability.hideResult, _me));
  Hafas.ps.sub('/reachability/postForm', Hafas.bind(_me.Controller.Reachability.postForm, _me));
  Hafas.ps.sub('/reachability/startSearch', Hafas.bind(_me.Controller.Reachability.startSearch, _me));
  Hafas.ps.sub('/suggest/selectitem/ReachabilityLocation', Hafas.bind(_me.Controller.Reachability.setLocation, _me));
  Hafas.ps.sub('/common/currentPositionActivated/ReachabilityLocation', Hafas.bind(_me.Controller.Reachability.setLocation, _me));
  Hafas.ps.sub('/common/currentPositionActivated/ReachabilityLocation', Hafas.bind(_me.Controller.Reachability.setLocationMarker, _me));
  Hafas.ps.sub('/reachability/changeDisplayMode', Hafas.bind(_me.Controller.Reachability.changeDisplayMode, _me));
  Hafas.ps.sub('/reachability/changeMode', Hafas.bind(_me.Controller.Reachability.changeMode, _me));
  Hafas.ps.sub("/reachability/loadResultComplete", Hafas.bind(_me.Controller.Reachability.showResult, _me));
  Hafas.ps.sub("/reachability/changeDay", Hafas.bind(_me.Controller.Reachability.changeDay, _me));
  Hafas.ps.sub('/reachability/changeTravelTime', Hafas.bind(_me.Controller.Reachability.changeTravelTime, _me));
  Hafas.ps.sub('/reachability/changePeriod', Hafas.bind(_me.Controller.Reachability.changePeriod, _me));
  Hafas.ps.sub('/reachability/locationUpdated', Hafas.bind(_me.Controller.Reachability.updateLocationDisplay, _me));
  Hafas.ps.sub('/reachability/selectProduct', Hafas.bind(_me.Controller.Reachability.selectProduct, _me));
  Hafas.ps.sub('/reachability/setDate', Hafas.bind(_me.Controller.Reachability.setDate, _me));
  Hafas.ps.sub('/reachability/setTime', Hafas.bind(_me.Controller.Reachability.setTime, _me));
  Hafas.ps.sub('/reachability/setTimeNow', Hafas.bind(_me.Controller.Reachability.setTimeNow, _me));

  Hafas.ps.sub("/reachability/update", Hafas.bind(_me.Controller.Reachability.startSearch, _me));

  Hafas.ps.sub("/reachability/clearInput", Hafas.bind(_me.Controller.Reachability.clearInput, _me));

  // Popover
  Hafas.ps.sub('/reachability/favorites/showPopover', Hafas.bind(_me.Controller.Reachability.showLocationSelectionPopover,_me));
  Hafas.ps.sub('/reachability/favorites/closeLocationPopover', Hafas.bind(_me.Controller.Reachability.hideLocationSelectionPopover, _me));
  Hafas.ps.sub('/favorites/closeLocationPopover', Hafas.bind(_me.Controller.Reachability.hideLocationSelectionPopover, _me));

  // DateTime Picker
  Hafas.ps.sub('/dateTimePicker/selectDateTime/ReachabilityDTP', Hafas.bind(_me.Controller.Reachability.selectDateTimeFromPicker, _me));

  Hafas.ps.sub('/GUI/leaveContext/Reachability', Hafas.bind(_me.Controller.Reachability.cleanup, _me));
  Hafas.ps.sub('/GUI/closeView/Reachability', Hafas.bind(_me.Controller.Reachability.closeView, _me));
  Hafas.ps.sub('/GUI/restoreView/Reachability', Hafas.bind(_me.Controller.Reachability.restoreView, _me));

  // Ergebnisse verarbeiten
  Hafas.ps.sub('/reachability/processResults/', Hafas.bind(function () {
    Hafas.bind(_me.Controller.Reachability.toggleErrorHint, _me)('hide');
  }, _me));

  // Keine Ergebnisse / HCI Fehler
  Hafas.ps.sub('/reachability/noResultsFound/', Hafas.bind(function () {
    Hafas.bind(_me.Controller.Reachability.toggleErrorHint, _me)('show');
  }, _me));

  // Favoriten-Button von Reachability
  Hafas.ps.sub('/reachability/setLocationMarker', Hafas.bind(_me.Controller.Reachability.setLocationMarker, _me));

};
